import { render, staticRenderFns } from "./rewardSuperBombEdit.vue?vue&type=template&id=1cf8f933&scoped=true&"
import script from "./rewardSuperBombEdit.vue?vue&type=script&lang=js&"
export * from "./rewardSuperBombEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf8f933",
  null
  
)

export default component.exports